module.exports = __webpack_public_path__ + "24_kdd.jpg?7ba6af0e09f2b718ac0e4df715eed633";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/24_kdd.jpg
// module id = 209
// module chunks = 0